import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';

import { ChargeColumnComponent } from '@ruby/shared/inventory-management/charge-column/charge-column.component';

@NgModule({
  declarations: [ChargeColumnComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    MatListModule,
    MatMenuModule
  ],
  exports: [ChargeColumnComponent]
})
export class ChargeColumnModule {}
